const config = {
  // IMAGE_PREFIX: process.env.NODE_ENV === 'production' ? 'https://ratshyh.wzgo.cn' : 'http://localhost:8080',
  // API_URL: process.env.NODE_ENV === 'production' ? 'https://ratshyh.wzgo.cn' : 'http://localhost:8080',
  IMAGE_PREFIX: process.env.NODE_ENV === 'production' ? 'https://ratshyh.wzgo.cn' : 'https://ratshyh.wzgo.cn',
  API_URL: process.env.NODE_ENV === 'production' ? 'https://ratshyh.wzgo.cn' : 'https://ratshyh.wzgo.cn',
  widthLimit: 600
};
export default config;
